module.exports = __webpack_public_path__ + "static/media/icon_adicionar_ao_carrinho.36e88d85.svg";